<template lang="pug">
v-layout(row, wrap)
  v-flex.md12.Poppins
    v-card.cardPadrao
      v-card-text
        v-layout.areaScrool(row, wrap)
          div(style="width:100%;", v-if="!list.length && loading")
              v-progress-linear(:indeterminate="true")
          div.avisoBox(v-if="!list.length && !loading")
            span Você não possui boletos pendentes
          v-card.pa-2.ma-2.br-10.cardBoleto(v-for="item in list", :key="item.id")
              v-layout.pa-2(row, wrap, style="cursor: pointer", @click="visualizarBoleto(item)")
                  v-flex.md8.xs9.Poppins
                    span.Poppins.Capitalize(style="font-size: 20px;font-weight: 500") {{ item.referencia }}
                      small(v-if="item.indice !== '1/1'", style="color: ###1113128A;") &nbsp; ({{ item.indice }})
                    br
                    span.captalize {{ $dayjs(item.data_vencimento).format('DD/MM/YYYY') }}
                    br
                    br
                    span.subheading.font-weight-bold.primary--text {{ item.valor | currency }}
                  v-flex.md4.xs3.pa-0.ma-0(style="display: flex; align-items: center;justify-content: right;")
                    v-chip(small,:style="{'color': getStatusBoleto(item).color, 'background': getStatusBoleto(item).backgroundcolor}").font-weight-bold {{getStatusBoleto(item).label.toUpperCase()}}

  v-dialog(v-model="dialog.fatura", max-width="700", v-if="boleto && boleto.estabelecimento && boleto.estabelecimento.id")
    v-card.br-10
      v-card-title
        v-layout(row, wrap).mt-3
          v-flex.md6.text-xs-left
            h4.font-weight-bold BOLETO
              br
              small.mt-3 {{ boleto.referencia }}
          v-flex.md6.text-xs-right
            v-chip(:style="{'color': getStatusBoleto(boleto).color, 'background': getStatusBoleto(boleto).backgroundcolor}").font-weight-bold {{getStatusBoleto(boleto).label.toUpperCase()}}
      v-card-text
        v-divider(v-if="boleto.parcelas.length > 1")
        v-layout(row, wrap, v-if="boleto.parcelas.length > 1").mt-2
          v-flex.md12(v-for="boleto in boleto.parcelas", :key="boleto.id")
            .body-1 {{ $root.createReferenciaBoletos([boleto]) }}
              span.caption(v-if="boleto.indice !== '1/1'") ({{ boleto.indice }})
              span.font-weight-medium ({{ boleto.valor | currency }})
        v-divider.mt-3
        v-layout(row, wrap).mt-2
          v-flex.md6.text-xs-center
            .subtitle-1.font-weight-medium(color="blue-grey lighten-2") Vencimento
            .body-1.font-weight-regular(v-if="boleto.data_vencimento !== boleto.data_base_vencimento", style="text-decoration: line-through!important;") {{ $dayjs(boleto.data_base_vencimento).format('DD/MM/YYYY') }}
            .headline.font-weight-light {{ $dayjs(boleto.data_vencimento).format('DD/MM/YYYY') }}
          v-flex.md6.text-xs-center
            .subtitle-1.font-weight-medium(color="blue-grey lighten-2") Valor
            .headline.font-weight-light {{ boleto.valor | currency }}
        v-layout(row, wrap, v-if="isReembolso(boleto) || isCobravel(boleto) || isNotCobravel(boleto)").mt-3
          v-flex.md12.text-xs-center
            .caption(v-if="isReembolso(boleto)", style="color:#007AFF;") * O valor será repassado pelo nosso financeiro ou será abatido na próxima cobrança.
            .caption(v-if="isCobravel(boleto)", style="color:#FF0F00;") * Sujeito a cobrança de multa e juros por atraso.
            .caption(v-if="isNotCobravel(boleto)", style="color:#E65300;") * Valores abaixo de R${{ $root.enums.VALOR_MINIMO_BOLETO }} serão adicionados aos próximos boletos até que se complete o valor mínimo para pagamento.
        v-divider.mt-3
        v-layout(row, wrap, v-if="isCobravel(boleto)").mt-3
          v-flex.text-xs-center
            v-btn.white--text(class="btnVerBoleto", @click="verBoleto(boleto)", :loading="loadingBoleto", color="primary") Ver Boleto
        v-layout(row, wrap, v-if="boleto.boleto && boleto.status !== -1").mt-3
          v-flex.text-xs-center
            .caption.font-weight-medium Código de barras:
            #codigo_barras {{ boleto.boleto.boleto_bar_code ? boleto.boleto.boleto_bar_code : boleto.boleto.payment_method ? boleto.boleto.payment_method.barcode : '' }}
              v-tooltip(top)
                v-btn(small, icon, @click="copiarCodigo", slot="activator")
                  v-icon(small, color="gray") file_copy
                span Copiar
      v-card-actions
        v-spacer
        v-btn(flat, type="button", @click="dialog.fatura = false;") Fechar

</template>

<script>

import _ from "lodash";

export default {
  data () {
    return{
      dialog: {
        fatura: false,
      },
      boleto : {},
      boletos: [],
      headers: [
        { text: 'Referência', value: 'nome', width: "25%", sortable:false },
        { text: 'Vencimento', value: 'vencimento', width: "25%", sortable:false},
        { text: 'Valor', value: 'valor', width: "25%", sortable:false},
        { text: 'Status', value: 'status', width: "25%", sortable:false},
      ],
      loading: false,
      loadingBoleto: false,
      rowPerPageConfig: [10,20,30,{text:'Todos','value':-1}]
    }
  },
  created () {

  },
  computed: {
    estabelecimentoSelecionado(){
      return this.$root.estabelecimentoSelecionado;
    },
    list () {
        const vm = this;
        return vm.boletos.sort(function(a,b){
          return vm.$dayjs(b.vencimento) - vm.$dayjs(a.vencimento);
        });
    }
  },
  methods: {
    refresh(estabelecimento_id){
      this.getBoletos(estabelecimento_id);
    },
    isReembolso(boleto){
      const vm        = this;
      const enums     = vm.$root.enums;
      return boleto.status == enums.STATUS.REEMBOLSO;
    },

    isCobravel(boleto){
      const vm        = this;
      const enums     = vm.$root.enums;
      return boleto.status == enums.STATUS.BOLETO_VENCENDO || boleto.status == enums.STATUS.BOLETO_VENCIDO || boleto.status == enums.STATUS.BOLETO_VIGENTE;
    },

    isNotCobravel(boleto){
      const vm        = this;
      const enums     = vm.$root.enums;
      return boleto.status == enums.STATUS.BOLETO_INSUFICIENTE;
    },

    showError (error){
      console.log(error);
      const vm = this;
      let err = error.response && error.response.data ? error.response.data.error : 'Ocorreu um erro ao buscar os boletos. Atualize a página!';
      window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
      vm.loading = false;
    },

    getStatusBoleto (boleto){
        const vm        = this;
        const enums     = vm.$root.enums;
        var colorLabel  = [];
        colorLabel[enums.STATUS.BOLETO_VENCENDO] = {
            backgroundcolor: "#FF950014",
            color : "#A66100",
            label : "VENCENDO"
        };
        colorLabel[enums.STATUS.BOLETO_PAGO] = {
            backgroundcolor: "#1D9A5A14",
            color : "#0F7641",
            label : "PAGO"
        };
        colorLabel[enums.STATUS.BOLETO_INSUFICIENTE] = {
            backgroundcolor: "#0060C80A",
            color : "#0060C8",
            label : "VALOR INSUFICIENTE"
        };
        colorLabel[enums.STATUS.BOLETO_VIGENTE] = {
            backgroundcolor: "#0060C80A",
            color : "#0060C8",
            label : "VIGENTE"
        };
        colorLabel[enums.STATUS.BOLETO_VENCIDO] = {
            backgroundcolor: "#DE3F310A",
            color : "#B30F00",
            label : "ATRASADO"
        };
        colorLabel[enums.STATUS.REEMBOLSO] = {
            backgroundcolor: "#1D9A5A14",
            color : "#0F7641",
            label : "REEMBOLSO"
        };
        return colorLabel[boleto.status] || {backgroundcolor:'',color: '', label: ''};
    },
    async getBoletos (estabelecimento_id) {
      const vm = this;
      try {
        vm.boletos = [];
        if (!estabelecimento_id) return;
        vm.loading = true;
        vm.boletos = await vm.$root.getBoletos(estabelecimento_id);
        vm.loading = false;
      } catch (error) {
        vm.showError(error);
      }
    },
    async visualizarBoleto (boleto) {
      const vm        = this;
      const status    = vm.$root.enums.STATUS;
      try {
        boleto.estabelecimento = vm.estabelecimentoSelecionado;
        vm.boleto = boleto;
        if (boleto.boleto_id && !boleto.boleto && boleto.conta_faturamento_id && (boleto.status == status.BOLETO_VENCENDO || boleto.status == status.BOLETO_VIGENTE)) { // boleto gerado e vigente
          vm.boleto.boleto = await vm.buscarBoleto(boleto.boleto_id, boleto.conta_faturamento_id);
        }
        vm.dialog.fatura = true;
      } catch (error) {
        vm.showError(error);
      }
    },
    async emitirBoleto (boleto) {
      const vm = this;
      try {
        const response = await vm.$axios.post('/fatura/boleto', boleto);
        if (!response.data.length) throw 'Erro ao emitir boleto';
        boleto.data_vencimento      = response.data[0].data_vencimento;
        boleto.boleto_id            = response.data[0].boleto_id;
        boleto.boleto_status        = response.data[0].boleto_status;
        boleto.conta_faturamento_id = response.data[0].conta_faturamento_id;
        boleto.status               = response.data[0].status;
        return boleto;
      } catch (error) {
        vm.showError(error);
      }
    },
    async buscarBoleto (boleto_id, conta_faturamento_id) {
      const vm = this;
      try {
        const response = await vm.$axios.get('/fatura/boleto', {
          params: {
            conta_faturamento_id : conta_faturamento_id,
            boleto_id: boleto_id,
          }
        });
        return response.data;
      } catch (error) {
        vm.showError(error);
      }
    },
    async verBoleto (boleto) {
      const vm        = this;
      const status    = vm.$root.enums.STATUS;
      try {

        if (boleto.valor < vm.$root.enums.VALOR_MINIMO_BOLETO) return false;

        vm.loadingBoleto = true;

        if (boleto.boleto_id && boleto.dados_faturamento_id && boleto.status == status.BOLETO_VENCIDO) { // boleto gerado e vencido
          boleto = await vm.emitirBoleto(boleto);
          boleto.boleto = await vm.buscarBoleto(boleto.boleto_id, boleto.conta_faturamento_id);
        } else if (!boleto.boleto_id) { // boleto não gerado
          boleto = await vm.emitirBoleto(boleto);
          boleto.boleto = await vm.buscarBoleto(boleto.boleto_id, boleto.conta_faturamento_id);
        }

        if (boleto.boleto)
          window.open(boleto.boleto.boleto_url ? boleto.boleto.boleto_url : boleto.boleto.payment_method ? boleto.boleto.payment_method.url : boleto.boleto.secure_url ? boleto.boleto.secure_url : boleto.boleto.payment && boleto.boleto.payment.banking_billet ? boleto.boleto.payment.banking_billet.link : boleto.boleto._links.payBoleto.printHref);

        vm.loadingBoleto = false;
      } catch (error) {
        vm.loadingBoleto = false;
        vm.showError(error);
      }
    },
    copiarCodigo () {
      const range = document.createRange();
      range.selectNode(document.getElementById("codigo_barras"));
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand("copy");
      window.getApp.$emit('APP_ALERT', { color: 'success', text: 'Código copiado!' });
    },
  }
}
</script>

<style scoped>
.Poppins {
    font-family: "Poppins", "Roboto", "Helvetica";
}
.Capitalize{
    text-transform: capitalize;
}
.br-5{
    border-radius: 5px !important;
}
.br-10{
    border-radius: 10px !important;
}
.cardPadrao{
    box-shadow:none !important;
    background-color: transparent;
    margin-bottom: 25px;
}
.cardBoleto{
  width: 100%;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05);
}
.btnVerBoleto{
  border-radius:5px;
}
.avisoBox{
    margin-top: 25px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.areaScrool{
  overflow-y: auto;
  height: 63vh;
  align-content: flex-start!important;
}

@media screen and (max-width: 960px) {
    .avisoBox img{
        width: 90%;
        height: auto;
        max-width: 500px;
        max-height: 500px;
    }
}
</style>
